import { Component } from "react";
import { useNavigate } from "react-router-dom";

const withRouter = (Component) => {
  const Wrapper = (props) => {
    const navigate = useNavigate();

    return <Component navigate={navigate} {...props} />;
  };

  return Wrapper;
};

class ErrorBoundary extends Component {
  componentDidCatch(_error, _errorInfo) {
    this.props.navigate("/error");
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
